"use strict";

const stringConstants = {
    everist_blue: 'rgb(93, 133, 171)',
    result_red: 'rgb(180, 36, 25)',
    result_orange: 'rgb(231, 149, 49)',
    result_yellow: 'rgb(249, 250, 122)',
    result_green: 'rgb(125, 166, 46)',
    result_blue: 'rgb(51, 143, 184)',
    result_red_slider: 'rgb(224, 43, 29)',
    result_orange_slider: 'rgb(255, 165, 56)',
    result_green_slider: 'rgb(169, 216, 78)',
    result_blue_slider: 'rgb(51, 143, 184)',
    result_gray: 'rgb(78, 78, 76)',
    result_white: 'rgb(255, 255, 255)',
    result_black: 'rgb(0, 0, 0)',
    no_input_value_string: '&bull;&bull;&bull;',
    // var no_output_value_string: '00y 00m 00d',
    no_output_value_string: 'N/A',
    no_age_text: '00',
};
export default stringConstants;
